import * as React from "react";
import { Status, Statuses, StatusSize } from "azure-devops-ui/Status";
import "./Status.Example.css";

export default class StatusExample extends React.Component {
    public render() {
        return (
            <div className="flex-column">
                <div className="flex-row" style={{ flexWrap: "wrap" }}>
                    <div className="flex-column status-example-column">
                        <span>Success</span>
                        <Status
                            {...Statuses.Success}
                            key="success"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Failed</span>
                        <Status
                            {...Statuses.Failed}
                            key="failed"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Warning</span>
                        <Status
                            {...Statuses.Warning}
                            key="warning"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Information</span>
                        <Status
                            {...Statuses.Information}
                            key="information"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Running</span>
                        <Status
                            {...Statuses.Running}
                            key="running"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Waiting</span>
                        <Status
                            {...Statuses.Waiting}
                            key="waiting"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Queued</span>
                        <Status
                            {...Statuses.Queued}
                            key="queued"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Canceled</span>
                        <Status
                            {...Statuses.Canceled}
                            key="canceled"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                    <div className="flex-column status-example-column">
                        <span>Skipped</span>
                        <Status
                            {...Statuses.Skipped}
                            key="skipped"
                            size={StatusSize.m}
                            className="status-example flex-self-center "
                        />
                    </div>
                </div>
                {/* <span>Status with text</span>
                <div className="flex-row status-example" style={{ flexWrap: "wrap" }}>
                    <Status
                        {...Statuses.Success}
                        key="success"
                        size={StatusSize.xl}
                        text="Success status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Failed}
                        key="failed"
                        size={StatusSize.xl}
                        text="Failed status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Warning}
                        key="warning"
                        size={StatusSize.xl}
                        text="Warning status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Information}
                        key="information"
                        size={StatusSize.xl}
                        text="Information status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Running}
                        key="running"
                        size={StatusSize.xl}
                        text="Running status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Waiting}
                        key="waiting"
                        size={StatusSize.xl}
                        text="Waiting status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Queued}
                        key="queued"
                        size={StatusSize.xl}
                        text="Queued status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Canceled}
                        key="canceled"
                        size={StatusSize.xl}
                        text="Canceled status"
                        className="status-example"
                    />
                    <Status
                        {...Statuses.Skipped}
                        key="skipped"
                        size={StatusSize.xl}
                        text="Skipped status"
                        className="status-example"
                    />
                </div> */}
            </div>
        );
    }
}
